import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { ContentLayout } from '../../../../components/ContentLayout';
import { isValidCode } from '../../../../utils/validation';
import { ConfirmationSmsCodeForm } from '../../../../components/ConfirmationSmsCodeForm';
import { ESendSmsStatus } from '../../../../types/registration';
import { EActiveView } from '../../../../types/view';
import { ESentEmailType } from '../../../../types/sentEmail';
import { EEventType } from '../../../../../index';
import { trackConfirmPhoneConfirmClick, trackConfirmPhoneResendClick } from '../../../../utils/tracking';
var RESEND_TIMEOUT = 60;
export function FormContainer(_ref) {
  var sendSmsStatus = _ref.sendSmsStatus,
    isSubmitting = _ref.isSubmitting,
    phone = _ref.phone,
    email = _ref.email,
    hasCodeError = _ref.hasCodeError,
    codeError = _ref.codeError,
    sendSms = _ref.sendSms,
    changeView = _ref.changeView,
    confirmPhone = _ref.confirmPhone,
    emit = _ref.emit;
  var prevSendValidationCodeStatus = React.useRef(sendSmsStatus);
  // FORM
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    touched = _React$useState2[0],
    setTouched = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    changed = _React$useState4[0],
    setChanged = _React$useState4[1];

  //REQUIRED ARGS

  // CODE
  var codeRef = React.useRef(null);
  var _React$useState5 = React.useState(''),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    code = _React$useState6[0],
    setCode = _React$useState6[1];
  var isCodeInvalid = React.useMemo(function () {
    return code === '' || code !== '' && !isValidCode(code);
  }, [code]);
  var _React$useState7 = React.useState(new Date().getTime()),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    lastAttemptTimestamp = _React$useState8[0],
    setLastAttemptTimestamp = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    resendAvailable = _React$useState10[0],
    setResendAvailable = _React$useState10[1];
  var validateCode = React.useCallback(function (code) {
    if (!isValidCode(code)) {
      if (codeRef.current) {
        codeRef.current.focus();
      }
      return;
    }
    confirmPhone({
      email: email,
      phone: phone,
      code: code
    });
    emit(EEventType.ConfirmPhoneConfirmClick);
    setChanged(false);
  }, [confirmPhone, email, phone, emit]);
  var handleChangeCode = React.useCallback(function (e) {
    var value = e.currentTarget.value;
    var newValue = value.replace(/\D/gi, '');
    if (newValue.length > 4) {
      return;
    }
    setChanged(true);
    setCode(newValue);
    validateCode(newValue);
  }, [validateCode]);
  var handleTimeoutExpired = React.useCallback(function () {
    setResendAvailable(true);
  }, []);
  var handleResendClick = React.useCallback(function (e) {
    e.preventDefault();
    if (sendSmsStatus !== ESendSmsStatus.Succeed) {
      return;
    }
    trackConfirmPhoneResendClick();
    emit(EEventType.ConfirmPhoneResendClick);
    sendSms({
      email: email,
      phone: phone
    });
    setCode('');
    if (codeRef.current) {
      codeRef.current.focus();
    }
  }, [sendSmsStatus, emit, sendSms, email, phone]);

  // FORM
  var handleSubmit = React.useCallback(function () {
    trackConfirmPhoneConfirmClick();
    setTouched(true);
    validateCode(code);
  }, [validateCode, code]);
  var skipConfirmation = React.useCallback(function () {
    changeView(EActiveView.EmailSent, {
      type: ESentEmailType.Registration,
      email: email
    });
    emit(EEventType.ConfirmPhoneCancelClick);
  }, [email, emit, changeView]);
  React.useEffect(function () {
    if (prevSendValidationCodeStatus.current !== sendSmsStatus) {
      if (sendSmsStatus === ESendSmsStatus.Failed) {
        setLastAttemptTimestamp(null);
      } else if (sendSmsStatus === ESendSmsStatus.Succeed) {
        setLastAttemptTimestamp(new Date().getTime());
      }
      setResendAvailable(false);
    }
    prevSendValidationCodeStatus.current = sendSmsStatus;
  }, [sendSmsStatus]);
  React.useEffect(function () {
    if (codeRef.current) {
      codeRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/React.createElement(ContentLayout, null, /*#__PURE__*/React.createElement(ConfirmationSmsCodeForm
  //FORM
  , {
    isSubmitting: isSubmitting,
    handleSubmit: handleSubmit,
    submitButtonText: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C"
    //CODE
    ,
    codeRef: codeRef,
    code: code,
    onCodeChange: handleChangeCode,
    codeError: !changed && codeError || undefined,
    isCodeInvalid: touched && (isCodeInvalid || !changed && hasCodeError),
    resendAvailable: resendAvailable,
    resendTimeout: RESEND_TIMEOUT,
    lastResendTime: lastAttemptTimestamp,
    onResendTimeoutExpired: handleTimeoutExpired,
    onResend: handleResendClick,
    buttons: /*#__PURE__*/React.createElement(Button, {
      "data-name": "SkipPhoneConfirmationBtn",
      theme: "fill_white_primary",
      fullWidth: true,
      onClick: skipConfirmation
    }, "\u0421\u0434\u0435\u043B\u0430\u044E \u043F\u043E\u0437\u0436\u0435")
  }));
}